import { put, takeLatest, all, call, takeMaybe, takeEvery } from 'redux-saga/effects';
import { api } from '../utils/api';
import { PROVIDER } from '../utils/settings';

function* getStations(action) {
    try {
        let response = null;
        if (action.payload.bounds) {
            var groups = '';
            var connectors = '';
            var power_from = action.payload.filter.power && action.payload.filter.power.from ? action.payload.filter.power.from : 0;
            var power_to = action.payload.filter.power && action.payload.filter.power.to ? action.payload.filter.power.to : 350000;
            var beoeFound = false;
    
            if (action.payload.filter.groups) {
                for(var group of action.payload.filter.groups) {
    
                    if(group.active && group.name.indexOf('_offline') === -1) {
                        groups += group.id + ',';
                    }
                    else if (PROVIDER === 'EST' && group.name === 'egg' && group.active && beoeFound) {
                        groups += group.id + ',';
                    }
                    else if (PROVIDER === 'EGG' && group.name === 'est' && group.active && beoeFound) {
                        groups += group.id + ',';
                    }
                }
                groups = groups.replace(/,\s*$/, "");
            }

            if (action.payload.filter.connectors) {
                for (var connector of action.payload.filter.connectors) {
                    if(connector.active) {
                        connectors += connector.icon + ',';
                    }
                }
                connectors = connectors.replace(/,\s*$/, "");
            }

            let url = `stations/?region_ng_west=${action.payload.bounds[0]}&region_lat_south=${action.payload.bounds[1]}&region_lng_east=${action.payload.bounds[2]}&region_lat_north=${action.payload.bounds[3]}&power_from=${power_from}&power_to=${power_to}&groups=${groups}&connectors=${connectors}&provider=${PROVIDER}`;
            response = yield call(api.get, url);
        }
        else
            response = yield call(api.get, `stations/?provider=${PROVIDER}`);

        if (response.ok) {
            yield put({type: "GET_STATIONS_SUCCESS", stations: response.data.result});
        }
    } catch (error) {
        console.log(error)
    }
}

function* getStation(action) {
    try {
        let response = yield call(api.get, `stations/${action.payload.uuid}/?provider=${PROVIDER}`);
        if (response.ok) {
            yield put({type: "GET_STATION_SUCCESS", station: response.data.result});
        }
    } catch (error) {
        console.log(error)
    }
}

function* setGeoPosition(action) {
    yield put({type: "SET_GEO_POSITION", position: action.payload.position});
}

function* resetStation() {
    yield put({type: "RESET_STATION"});
}

function* resetFilter() {
    yield put({type: "RESET_STATION"});
}

function* saveFilterData(action) {
    yield put({type: "SET_FILTER_DATA_SUCCESS", filter_data: action.payload.filter});
}

function* getFilterData(action) {
    try {
        let response = null;

        let params = (new URL(document.location)).searchParams;
        if (params.has('groups')) {
            response = yield call(api.get, `stations/filters/?provider=${PROVIDER}&groups=${params.get('groups')}`);
        } else {
            response = yield call(api.get, `stations/filters/?provider=${PROVIDER}`);
        }
        
        if (response.ok) {
            yield put({type: "SET_FILTER_DATA_SUCCESS", filter_data: response.data.result});
        }
    } catch (error) {
        console.log(error)
    }
}

function* actionWatcher() {
    yield takeLatest('SAVE_FILTER_DATA', saveFilterData)
    yield takeEvery('SET_FILTER_DATA', getFilterData)
    yield takeLatest('GET_STATIONS', getStations)
    yield takeLatest('GET_STATION', getStation)
    yield takeMaybe('RESET_STATION', resetStation)
    yield takeMaybe('SET_GEO_POSITION', setGeoPosition)
    yield takeMaybe('RESET_FILTER', resetFilter)
}

export default function* rootSaga() {
    yield all([
        actionWatcher(),
    ]);
}